module.exports = __webpack_public_path__ + "media/images/flags/16/Nicaragua-b63dc478fdb6473c04d1a9fd3d485978.png";